import * as htmlparser2 from 'htmlparser2'

export function parseProductSpecification(tableHTML) {
  if (!tableHTML || !tableHTML.length) {
    return []
  }

  try {
    const rows = []

    const parser = new htmlparser2.Parser({
      onopentag(name) {
        if (name === 'tr') {
          this.currentRow = []
        }
        if (name === 'th' || name === 'td') {
          this.currentCell = ''
        }
        if (name === 'br') {
          if (this.currentCell !== undefined) {
            this.currentCell += '\n'
          }
        }
      },
      ontext(text) {
        if (this.currentCell !== undefined) {
          this.currentCell += text.trim()
        }
      },
      onclosetag(tagname) {
        if (tagname === 'tr') {
          rows.push(this.currentRow)
          this.currentRow = undefined
        }
        if (tagname === 'th' || tagname === 'td') {
          if (this.currentRow) {
            this.currentRow.push(this.currentCell)
          }
          this.currentCell = undefined
        }
      },
    })
    parser.write(tableHTML)
    parser.end()

    const specifications = []

    rows.forEach((row) => {
      if (row?.length === 2) {
        const name = row[0].trim()
        const value = row[1].trim()
        specifications.push({ name, value })
      }
    })

    return specifications
  } catch (e) {
    console.log('failed to parseProductSpecification', e.message)
    return []
  }
}
